import { j as e } from "./jsx-runtime-B6kdoens.js";
import * as f from "react";
import { useEffect as j } from "react";
import { c as n, L as g } from "./logo-svg-embed-Cp82pc6m.js";
import { u as N } from "./outside-click-wx59LN8I.js";
import { u as y } from "./drawer-border-DBxafmnT.js";
import { C as u } from "./product-utils-BZ9FKiCb.js";
import "@fortawesome/react-fontawesome";
import "@fortawesome/pro-regular-svg-icons";
import { L as C } from "./logo-svg-embed-DHUx4kkg.js";
const F = ({
  responsiveStyles: s,
  className: r,
  filter: a,
  toolbar: l,
  header: i,
  children: o
}) => /* @__PURE__ */ e.jsxs("div", { className: n("page-layout", s, r), children: [
  /* @__PURE__ */ e.jsxs("div", { className: "page-header-container", children: [
    i,
    a && /* @__PURE__ */ e.jsx("div", { className: "filter-container", children: a }),
    l && /* @__PURE__ */ e.jsx("div", { className: "page-toolbar", children: l })
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "page-children-container", children: o })
] }), R = ({
  title: s,
  badge: r,
  subTitle: a,
  image: l,
  breadcrumb: i,
  middlePane: o,
  className: c,
  children: d,
  drawerColorEnabled: m = !1,
  drawerBorderEnabled: t = !1,
  baseColor: v = u.navy,
  backgroundColor: p = u.sky
}) => {
  const h = N({
    bgColor: p,
    color: v
  }), x = y();
  return j(() => (m && h.toggleColor(), () => h.revertColor()), []), j(() => (t && x.toggleBorder(), () => x.revertBorder()), []), /* @__PURE__ */ e.jsxs("div", { className: n("page-header", c), children: [
    /* @__PURE__ */ e.jsxs("div", { className: n("info-container", o && "has-middle-pane"), children: [
      i && /* @__PURE__ */ e.jsx("div", { children: i }),
      /* @__PURE__ */ e.jsxs("div", { className: "info", children: [
        l && /* @__PURE__ */ e.jsx("div", { className: "image", children: l }),
        /* @__PURE__ */ e.jsxs("div", { className: "text", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "title-container", children: [
            /* @__PURE__ */ e.jsx("h1", { children: s }),
            " ",
            r && /* @__PURE__ */ e.jsx("span", { className: "badge", children: r })
          ] }),
          a && /* @__PURE__ */ e.jsx("h3", { children: a })
        ] })
      ] })
    ] }),
    o && /* @__PURE__ */ e.jsx("div", { className: "middle-pane-container", children: o }),
    /* @__PURE__ */ e.jsx("div", { className: "toolbar-container", children: d })
  ] });
}, _ = ({
  title: s,
  image: r,
  className: a,
  children: l,
  footer: i,
  showMobileImage: o
}) => {
  const c = Array.isArray(s) ? s : [s], d = c.length - 1;
  return /* @__PURE__ */ e.jsxs("div", { className: n("account-layout", a), children: [
    /* @__PURE__ */ e.jsx("div", { className: "left", children: /* @__PURE__ */ e.jsxs("div", { className: "content", children: [
      /* @__PURE__ */ e.jsx("header", { children: /* @__PURE__ */ e.jsx(C, {}) }),
      /* @__PURE__ */ e.jsx("h1", { children: c.map((m, t) => /* @__PURE__ */ e.jsxs(f.Fragment, { children: [
        m,
        t < d && /* @__PURE__ */ e.jsx("br", {})
      ] }, t)) }),
      l,
      o && /* @__PURE__ */ e.jsx(
        "div",
        {
          className: "bottom",
          style: { backgroundImage: `url(${r})` }
        }
      ),
      i
    ] }) }),
    /* @__PURE__ */ e.jsx("div", { className: "right", style: { backgroundImage: `url(${r})` } })
  ] });
};
function P({ className: s, terms: r, privacyPolicy: a }) {
  return /* @__PURE__ */ e.jsxs("footer", { className: n(s), children: [
    /* @__PURE__ */ e.jsxs("div", { children: [
      "Copyright © ",
      (/* @__PURE__ */ new Date()).getFullYear(),
      " Transfr Inc. All Rights Reserved."
    ] }),
    /* @__PURE__ */ e.jsxs("ul", { children: [
      /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(g, { href: a, underline: !0, children: "Privacy Policy" }) }),
      /* @__PURE__ */ e.jsx("li", { children: /* @__PURE__ */ e.jsx(g, { href: r, underline: !0, children: "Terms of Use" }) })
    ] })
  ] });
}
export {
  P as LegalFooter,
  R as PageHeader,
  F as PageLayout,
  _ as SideImageLayout
};
